import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { blue, green, red } from '@material-ui/core/colors'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import DoneIcon from '@material-ui/icons/Done'
import BlockIcon from '@material-ui/icons/Block'
import LoopIcon from '@material-ui/icons/Loop'
import ErrorIcon from '@material-ui/icons/Error'

const useStyles = makeStyles((theme) => (
    {
        error: {
            backgroundColor: red[400],
            color: "#fff",
        },
        info: {
            backgroundColor: blue[400],
            color: "#fff",
        },
        success: {
            backgroundColor: green[400],
            color: "#fff",
        },
        icon: {
            color: "#fff",
        }
    }
));

const ChipStatus = ({ status }) => {
    const classes = useStyles();

    return (
        <Chip
            size="small"
            icon={status === 'SUCESSO' ? <DoneIcon className={classes.icon} /> : status === 'FALHA' ? <ErrorIcon className={classes.icon} /> : status === 'AGUARDANDO' ? <LoopIcon className={classes.icon} /> : <BlockIcon className={classes.icon} />}
            label={<b>{status === 'SUCESSO' ? 'Sucesso' : status === 'FALHA' ? 'Falha' : status === 'AGUARDANDO' ? 'Aguardando' : 'Descartado'}</b>}
            className={status === 'SUCESSO' ? classes.success : status === 'FALHA' ? classes.error : status === 'AGUARDANDO' ? classes.info : null}
        />
    )
}

const patternTypeMail = (type) => type;

export const EmailViewer = ({to, status, type, subject, message}) => {
    return (
        <Grid container spacing={3} alignItems='center'>
            <Grid item sm={12} lg={12}>
                <Paper elevation={1} style={{ padding: 24 }} >
                    <Grid style={{ paddingBottom: 24 }}>
                        <Typography variant="body2"><b>Para:</b> {to}</Typography>
                    </Grid>

                    <Grid style={{ paddingBottom: 24 }}>
                        <Typography variant="body2">
                            <b>Status de Envio:  </b><ChipStatus status={status} />
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography variant="body2"><b>Tipo de Email:</b> {patternTypeMail(type)}</Typography>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item sm={12} lg={12}>
                <Paper elevation={1} style={{ padding: 24 }} >
                    <Typography variant="h6">Assunto:</Typography>
                    <Typography variant="body2">{subject}</Typography>
                </Paper>
            </Grid>
            <Grid item sm={12} lg={12}>
                <Paper elevation={1} style={{ padding: 24 }} >
                    <Typography variant="h6">Mensagem:</Typography>              
                    <Typography variant="body2" dangerouslySetInnerHTML={{ __html: message }}></Typography>
                </Paper>
            </Grid>
        </Grid>
    )
}

export default EmailViewer;